var exports = {
  "e": "TransferOwnershipModal.module__warningBox___TUhESm",
  "i": "TransferOwnershipModal.module__warningText___TUhESm",
};

module.exports = exports;
